<template>
    <el-input
        v-model="input"
        :placeholder="placeholder"
        class="input-with-select"
        :class="{ 'input-with-select--open': focused }"
        @blur="$emit('blur')"
    >
        <template #append>
            <el-select v-model="select" @visible-change="focused = !focused">
                <el-option
                    v-for="option in options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                >
                </el-option>
            </el-select>
        </template>
    </el-input>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        modelValue: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            focused: false,
        };
    },
    computed: {
        input: {
            get() {
                return this.modelValue.input;
            },
            set(input) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    input,
                });
            },
        },
        select: {
            get() {
                return this.modelValue.select;
            },
            set(select) {
                this.$emit('update:modelValue', {
                    ...this.modelValue,
                    select,
                });
            },
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.input-with-select.el-input.el-input-group {
    .el-input-group__append .el-select {
        margin: 0;
    }
    .el-input__inner {
        height: auto;
    }
    .el-input-group__append {
        color: $gray-60;
        width: 100px;
    }
}
</style>
